var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloseChip = function SvgIconCloseChip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E62828",
    fillRule: "evenodd",
    d: "M4.594 13.841a1.458 1.458 0 1 0 2.062 2.063L10 12.56l3.344 3.344a1.458 1.458 0 0 0 2.062-2.063l-3.344-3.344 3.344-3.343a1.458 1.458 0 0 0-2.062-2.063L10 8.435 6.656 5.09a1.458 1.458 0 0 0-2.062 2.063l3.343 3.343z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCloseChip;